module.exports = __webpack_public_path__ + "media/images/small-ec0eebac57f477b847340325e5735314.jpg";